<template>
  <div>
    <div class="goods-item">
      <div class="goods-img-wrap">
        <img
          class="goods-img"
          src="https://m.360buyimg.com/mobilecms/s750x750_jfs/t3052/99/5640471740/72435/4af3ec23/58787162Naea4a334.jpg!q80.dpg.webp"
          alt=""
        />
        <div class="tag">即将开始</div>
        <div class="sell-out" v-if="false">
          <div class="sell-out-text">已售罄</div>
        </div>
      </div>
      <div class="goods-info">
        <div class="goods-name">MONTBLANC万宝龙大班系列签字笔玫瑰金色162/112672</div>
        <div class="goods-price">
          <div class="letter">￥</div>
          <div class="num">2699.00</div>
        </div>
        <div class="limit">2人成团</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "goods",
  data() {
    return {};
  },
  components: {}
};
</script>

<style scoped lang="scss">
.goods-item {
  position: relative;
  background: #fff;
  width: 3.7rem;
  border-radius: 0.1rem;
  margin-bottom: .1rem;
  overflow: hidden;
  .goods-img-wrap {
    position: relative;
    height: 3.6rem;
    width: 3.7rem;
    border-radius: 0.1rem;
    > .goods-img {
      display: block;
      width: 100%;
      height: 100%;
    }
    > .tag {
      position: absolute;
      left: 0;
      top: .27rem;
      padding: 0 .22rem;
      height: .44rem;
      background:rgba(0,0,0,.4);
      border-radius: 0 .22rem .22rem 0;
      display: flex;
      align-items: center;
      color: #fff;
    }
    > .sell-out {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background:rgba(255,255,255,.8);
      display: flex;
      align-items: center;
      justify-content: center;
      .sell-out-text {
        width: 1.15rem;
        height: 1.15rem;
        background:rgba(0,0,0,.5);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .24rem;
        color: #fff;
      }
    }
  }
  .goods-info {
    padding: 0 0.2rem .28rem;
    .goods-name {
      font-size: 0.28rem;
      line-height: 0.38rem;
      color: #333;
      padding: .22rem 0;
    }
    .goods-price {
      display: flex;
      color: #FF2F2F;
      line-height: .36rem;
      .letter {
        position: relative;
        top: .03rem;
        font-size: .24rem;
      }
      .num {
        font-size: .36rem;
      }
    }
    .limit {
      position: absolute;
      bottom: .28rem;
      right: .2rem;
      color: #FF1300;
      background: #FFE6E6;
      border-radius: .05rem;
      padding: .04rem .1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/FightGroups/components/Goods.vue